import { render, staticRenderFns } from "./CategorySidebarListItem.vue?vue&type=template&id=f64b2aea&scoped=true&"
import script from "./CategorySidebarListItem.vue?vue&type=script&lang=js&"
export * from "./CategorySidebarListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64b2aea",
  null
  
)

export default component.exports